import { render, staticRenderFns } from "./status-radio.vue?vue&type=template&id=10d4a53a&scoped=true&"
import script from "./status-radio.vue?vue&type=script&lang=js&"
export * from "./status-radio.vue?vue&type=script&lang=js&"
import style0 from "./status-radio.vue?vue&type=style&index=0&id=10d4a53a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d4a53a",
  null
  
)

export default component.exports